// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import mail01Icon from "@/assets/icons/mail-01.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type Mail01IconProps = Omit<IconProps, "name">;

export function Mail01Icon(props: Mail01IconProps): React.ReactNode {
  return <Icon name={mail01Icon} {...props} />;
}
